import { formatDay } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/formats'
import { fieldStyles } from '@/features/pos/components/OrderFinalization/parts/FormFields/styles'
import Select from '@/features/ui/inputs/components/Select'
import Option from '@/features/ui/inputs/components/Select/parts/Option'
import { useScreenSize } from '@/hooks/screen'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface DaySelectorProps {
    days: string[]
    day: string
    onChange: (day: string) => void
}

const DaySelector: FC<DaySelectorProps> = ({ days, day, onChange }) => {
    const screenSize = useScreenSize()

    const { t } = useTranslation()

    return (
        <Select
            disabled={days.length <= 1}
            label={t('pos.orderFinalization.inputs.deliveryTime.daySelectorLabel')}
            placeholder=""
            value={day}
            onValueChange={onChange}
            containerStyle={{ zIndex: 1 }}
            style={screenSize === 'small' && fieldStyles.smallScreenField}
        >
            {days.map((day, index) => (
                <Option key={index} value={day}>
                    {formatDay(day, t)}
                </Option>
            ))}
        </Select>
    )
}

export default memo(DaySelector)
